<template>
	<div>
		<div class="row">
			<div class="col-5 mb-4">
				<h1>{{ $t("buildings") }}</h1>
			</div>
			<div class="col-7 mb-4">
				<router-link to="/timetables/buildings/add" class="float-right btn btn-primary"
					><b-icon icon="plus"></b-icon> {{ $t("new") }}</router-link
				>
			</div>
		</div>

		<Table
			:loading="!loaded"
			:data="buildings"
			:cols="[
				{ key: 'name', heading: $t('name'), size: 8 },
				{key: 'postcode', heading: $t('postcode'), size: 4},
				//{ key: 'lat', heading: $t('latitude'), size: 2 },
				//{ key: 'long', heading: $t('longitude'), size: 2 },
			]"
			breakpoint="sm"
			@selectItem="selectBuilding"
            @deleteItem="openDeleteDialog"
            :allowRightClick="true"
		/>
	</div>
</template>

<script>
import Table from "src/components/Table/Table.vue";

export default {
	components: {
		Table,
	},
	data: function () {
		return {
			buildings: [],
			loaded: false,
            selectedBuilding: null
		};
	},
	mounted() {
		this.getBuildings();
	},
	methods: {
		selectBuilding(building) {
			this.$router.push(`/timetables/buildings/${building.id}`);
		},
		getBuildings() {
			this.$cfetch(`${this.$settings.APIBaseURL}/timetable/ttbuilding/list`).then((res) => {
				this.buildings = res.results;
				this.loaded = true;
			});
		},
		openDeleteDialog(building) {
            this.selectedBuilding = building

            this.$store.commit('openDialog', {
                title: this.$t('are-you-sure'),
                content: this.$t('delete-{e}-warning',{e: this.$t('building')}),
                cancelBtn: true,
                confirmCallBack: this.removeBuilding,
            })
        },
        removeBuilding() {
            if (!this.selectedBuilding) return ;
            this.$cfetch(`${this.$settings.APIBaseURL}/timetable/ttbuilding/delete`, {
                method: 'POST',
                data: { id: this.selectedBuilding.id }
            }).then(res => {
                if (res.status !== 'SUCCESS') throw new Error('Unexpected error deleting provider')

                this.buildings = this.buildings.filter(el => el.id !== this.selectedBuilding.id)
            }).catch(err => {
                console.error(err)
                this.$log.error.call(this, err)
                this.$store.commit('openDialog', {
                    title: this.$t('something-went-wrong'),
                    content: this.$t('error-delete-{e}',{e:this.$t('building')}),
                })
            })
        }
	},
};
</script>
